// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","fixed":"Footer_fixed__Krb4P"};